<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div
    class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6"
  >
    <div class="flex items-center gap-3">
      <button
        type="button"
        (click)="goBack()"
        style="
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 8px 16px;
          background: white;
          color: #374151;
          border: 1px solid #d1d5db;
          border-radius: 10px;
          font-weight: 600;
          font-size: 0.85rem;
          cursor: pointer;
          transition: all 0.2s ease;
        "
        onmouseover="this.style.background = '#f3f4f6'"
        onmouseout="this.style.background = 'white'"
      >
        <mat-icon
          style="font-size: 18px; width: 18px; height: 18px; color: #374151"
          >arrow_back</mat-icon
        >
        Volver
      </button>
      <h1 class="text-xl md:text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon style="color: #1c593d; margin-right: 8px"
          >receipt_long</mat-icon
        >
        Transacciones pendientes por cajero
      </h1>
    </div>
  </div>

  <!-- Card Filtros -->
  <div
    class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6"
  >
    <div
      style="
        background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
        padding: 16px 24px;
        border-bottom: 2px solid #bbf7d0;
      "
    >
      <h2
        style="
          margin: 0;
          font-size: 1rem;
          font-weight: 700;
          color: #1e5a3f;
          display: flex;
          align-items: center;
          gap: 8px;
        "
      >
        <mat-icon
          style="font-size: 20px; width: 20px; height: 20px; color: #1c593d"
          >filter_list</mat-icon
        >
        Filtros
      </h2>
    </div>
    <div class="p-5">
      <div class="flex flex-col lg:flex-row items-end gap-4">
        <mat-form-field
          appearance="outline"
          class="modern-field w-full lg:w-96"
        >
          <mat-label>Cuenta</mat-label>
          <mat-select
            required
            [(ngModel)]="cuentaSeleccionada"
            (selectionChange)="onCuentaTrabajoChange()"
          >
            <mat-option>Seleccione cuenta</mat-option>
            <mat-option
              *ngFor="let cuenta of cuentasTrabajo"
              [value]="cuenta.cuenta_trabajo_id"
            >
              {{ cuenta.nombre | titlecase }}
              {{ cuenta.apellidos | titlecase }} - {{ cuenta.banco?.nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field flex-1">
          <mat-icon matPrefix style="color: #1c593d">search</mat-icon>
          <mat-label>Filtrar datos</mat-label>
          <input
            matInput
            type="text"
            (keyup)="doFilter($event)"
            placeholder="Filtrar datos"
          />
        </mat-form-field>

        <div class="flex gap-2 mb-1">
          <button
            *ngIf="!isObjectEmpty(cambios)"
            type="button"
            (click)="guardarSeleccion()"
            style="
              display: inline-flex;
              align-items: center;
              gap: 6px;
              padding: 8px 20px;
              background: #1c593d;
              color: white;
              border: none;
              border-radius: 10px;
              font-weight: 700;
              font-size: 0.85rem;
              cursor: pointer;
              transition: background 0.2s ease;
            "
            onmouseover="this.style.background = '#059669'"
            onmouseout="this.style.background = '#1C593D'"
          >
            <mat-icon
              style="font-size: 18px; width: 18px; height: 18px; color: white"
              >check</mat-icon
            >
            Guardar selección
          </button>
          <button
            type="button"
            (click)="refreshData()"
            style="
              display: inline-flex;
              align-items: center;
              gap: 6px;
              padding: 8px 20px;
              background: #1c593d;
              color: white;
              border: none;
              border-radius: 10px;
              font-weight: 700;
              font-size: 0.85rem;
              cursor: pointer;
              transition: background 0.2s ease;
            "
            onmouseover="this.style.background = '#059669'"
            onmouseout="this.style.background = '#1C593D'"
          >
            <mat-icon
              style="font-size: 18px; width: 18px; height: 18px; color: white"
              >refresh</mat-icon
            >
            Refrescar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Saldos Info Cards -->
  <div class="mb-6" *ngIf="cuentaSeleccionada">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div
        class="bg-white rounded-xl shadow-sm border border-gray-100 p-4 text-center"
      >
        <span class="text-xs font-semibold text-gray-500 uppercase"
          >Saldo Sistema</span
        >
        <p class="text-2xl font-bold mt-1" style="color: #16a34a">
          {{ saldoSistema | currency: "$" : "symbol" : "1.2-2" }}
        </p>
      </div>
      <div
        class="bg-white rounded-xl shadow-sm border border-gray-100 p-4 text-center"
      >
        <span class="text-xs font-semibold text-gray-500 uppercase"
          >Saldo Banco</span
        >
        <span class="block text-xs text-gray-400 mt-0.5"
          >(Última actualización)</span
        >
        <p class="text-2xl font-bold mt-1" style="color: #16a34a">
          {{ saldoBanco | currency: "$" : "symbol" : "1.2-2" }}
        </p>
      </div>
      <div
        class="bg-white rounded-xl shadow-sm border border-gray-100 p-4 text-center"
      >
        <span class="text-xs font-semibold text-gray-500 uppercase"
          >Diferencia</span
        >
        <p
          class="text-2xl font-bold mt-1"
          [class.text-gray-600]="diferenciaSaldo < 0"
          [class.text-red-600]="diferenciaSaldo > 0"
          [class.text-green-600]="diferenciaSaldo === 0"
        >
          {{ diferenciaSaldo | currency: "$" : "symbol" : "1.2-2" }}
        </p>
      </div>
    </div>
  </div>

  <!-- Validación de saldo -->
  <div
    class="mb-6"
    *ngIf="(counter >= 1 || saldosNoCoinciden) && cuentaSeleccionada"
  >
    <div
      class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden"
    >
      <div
        style="
          background: linear-gradient(135deg, #fefce8, #fef9c3);
          padding: 16px 24px;
          border-bottom: 2px solid #fde68a;
        "
      >
        <h2
          style="
            margin: 0;
            font-size: 1rem;
            font-weight: 700;
            color: #92400e;
            display: flex;
            align-items: center;
            gap: 8px;
          "
        >
          <mat-icon
            style="font-size: 20px; width: 20px; height: 20px; color: #f59e0b"
            >warning</mat-icon
          >
          Validación de saldo requerida
        </h2>
      </div>
      <div class="p-5">
        <p class="text-sm text-gray-500 mb-4 text-center">
          Se han realizado 2 pagos en esta cuenta de trabajo. Por favor ingresa
          el saldo que ves en la pantalla del banco.
        </p>
        <div
          class="flex flex-col md:flex-row gap-4 items-center justify-center"
        >
          <mat-form-field
            appearance="outline"
            class="modern-field w-full md:w-96"
            subscriptSizing="dynamic"
          >
            <mat-label>Saldo del Banco</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="balanceIngresado"
              placeholder="Ingresa el saldo actual"
              required
            />
            <span matTextPrefix>$&nbsp;</span>
          </mat-form-field>
          <button
            type="button"
            (click)="enviarBalanceBanco()"
            style="
              display: inline-flex;
              align-items: center;
              gap: 6px;
              padding: 10px 28px;
              background: #1c593d;
              color: white;
              border: none;
              border-radius: 10px;
              font-weight: 700;
              font-size: 0.9rem;
              cursor: pointer;
              transition: background 0.2s ease;
            "
            onmouseover="this.style.background = '#059669'"
            onmouseout="this.style.background = '#1C593D'"
          >
            <mat-icon
              style="font-size: 18px; width: 18px; height: 18px; color: white"
              >check_circle</mat-icon
            >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabla Desktop (columnas consolidadas) -->
  <div
    class="hidden lg:block bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden"
    *ngIf="dataSource"
  >
    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource">
        <!-- Seleccion -->
        <ng-container matColumnDef="seleccion">
          <th
            mat-header-cell
            *matHeaderCellDef
            style="width: 50px; text-align: center"
          >
            Sel.
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            style="width: 50px; text-align: center"
          >
            <mat-checkbox
              (change)="change($event, element.id)"
              [disabled]="
                checkEmailOperador(element.emailOperador) ||
                isProcesandoRail(element)
              "
              [checked]="element.emailOperador ? true : false"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="width: 55px">ID</th>
          <td mat-cell *matCellDef="let row" style="width: 55px">
            <span
              class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full"
              >{{ row.id }}</span
            >
          </td>
        </ng-container>

        <!-- ID Usuario -->
        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef style="width: 55px">
            ID Cliente
          </th>
          <td mat-cell *matCellDef="let row" style="width: 55px">
            <span
              class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full"
              >{{ row.userId }}</span
            >
          </td>
        </ng-container>

        <!-- Beneficiario (consolidado: nombre + DNI + ruta) -->
        <ng-container matColumnDef="beneficiario">
          <th mat-header-cell *matHeaderCellDef>Beneficiario</th>
          <td mat-cell *matCellDef="let row">
            <div class="leading-tight">
              <span class="text-xs font-semibold text-gray-800 block"
                >{{ row.cuentaBeneficiario?.nombre }}
                {{ row.cuentaBeneficiario?.apellidos }}</span
              >
              <span class="text-xs text-gray-500 font-mono block">{{
                row.cuentaBeneficiario?.numeroID
              }}</span>
              <span class="text-xs text-gray-400"
                >{{ row.paisOrigen }}-{{ row.paisDestino }}</span
              >
            </div>
          </td>
        </ng-container>

        <!-- Destino (consolidado: banco + tipo + cuenta) -->
        <ng-container matColumnDef="destino">
          <th mat-header-cell *matHeaderCellDef>Destino</th>
          <td mat-cell *matCellDef="let row">
            <div class="leading-tight">
              <span class="text-xs font-semibold text-gray-800 block">{{
                row.cuentaBeneficiario?.banco?.nombre
              }}</span>
              <span class="text-xs text-gray-500 block">{{
                row.cuentaBeneficiario?.tipoCuenta?.nombre?.toUpperCase()
              }}</span>
              <span class="text-xs text-gray-400 font-mono">{{
                row.cuentaBeneficiario?.numeroCuenta
              }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Monto Destino -->
        <ng-container matColumnDef="totalMonedaDestino">
          <th mat-header-cell *matHeaderCellDef style="width: 140px">Monto</th>
          <td mat-cell *matCellDef="let element" style="width: 140px">
            <div class="flex items-center gap-1">
              <span class="text-xs font-bold" style="color: #1e5a3f">
                {{
                  element.totalMonedaDestino
                    | currency: "$" : "symbol" : "1.0-2"
                }}
              </span>
              <button
                title="Copiar monto"
                [cdkCopyToClipboard]="
                  formatCurrencyForCopy(element.totalMonedaDestino)
                "
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 24px;
                  height: 24px;
                  border: 1px solid #d1d5db;
                  border-radius: 4px;
                  background: white;
                  cursor: pointer;
                "
                onmouseover="this.style.background = '#f3f4f6'"
                onmouseout="this.style.background = 'white'"
              >
                <mat-icon
                  style="
                    font-size: 12px;
                    width: 12px;
                    height: 12px;
                    color: #1c593d;
                  "
                  >content_copy</mat-icon
                >
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Precio Compra -->
        <ng-container matColumnDef="pago">
          <th mat-header-cell *matHeaderCellDef style="width: 170px">
            P. Compra
          </th>
          <td mat-cell *matCellDef="let element" style="width: 170px">
            <div class="flex items-center gap-1">
              <mat-form-field
                appearance="outline"
                class="modern-field"
                style="margin-top: 20px; max-width: 120px"
              >
                <input
                  matInput
                  matInputCommified
                  appOnlynumber
                  [id]="'valorCompra' + element.id"
                  [(ngModel)]="element.precio_compra"
                  [disabled]="
                    disableButton(element.emailOperador) ||
                    isProcesandoRail(element)
                  "
                  placeholder="$"
                />
              </mat-form-field>
              <button
                title="Guardar"
                (click)="setPurchaseValue(element.id, element.id)"
                [disabled]="
                  disableButton(element.emailOperador) ||
                  isProcesandoRail(element)
                "
                [style.opacity]="
                  disableButton(element.emailOperador) ||
                  isProcesandoRail(element)
                    ? '0.4'
                    : '1'
                "
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 28px;
                  height: 28px;
                  border: 1px solid #bbf7d0;
                  border-radius: 6px;
                  background: #f0fdf4;
                  cursor: pointer;
                "
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    color: #16a34a;
                  "
                  >save</mat-icon
                >
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Acciones -->
        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="width: 170px">
            Acciones
          </th>
          <td mat-cell *matCellDef="let element" style="width: 170px">
            <!-- Candado visual: si el rail automático (N58 / Banco Plaza) está
                 procesando la tx, se ocultan las acciones y se muestra un chip.
                 Como la query ASSIGNED sólo trae POR_PROCESAR, en cuanto el rail
                 resuelve la fila deja de venir y el candado desaparece solo. -->
            <!-- Rail procesando (N58 / Banco Plaza): se ocultan
                 asignar/aprobar/editar/reasignar, se DEJA sólo Rechazar. -->
            <div
              *ngIf="isProcesandoRail(element)"
              style="
                display: flex;
                align-items: center;
                gap: 4px;
                justify-content: center;
                flex-wrap: wrap;
              "
            >
              <span
                style="
                  display: inline-flex;
                  align-items: center;
                  gap: 4px;
                  padding: 4px 10px;
                  background: #fef9c3;
                  color: #92400e;
                  border-radius: 9999px;
                  font-size: 0.7rem;
                  font-weight: 700;
                  white-space: nowrap;
                "
              >
                <mat-icon style="font-size: 14px; width: 14px; height: 14px"
                  >hourglass_top</mat-icon
                >
                Procesando · {{ procesandoRail(element) }}
              </span>
              <button
                title="Rechazar"
                (click)="openRejectTransactionModal(element)"
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 28px;
                  height: 28px;
                  border: 1px solid #fecaca;
                  border-radius: 6px;
                  background: #fef2f2;
                  cursor: pointer;
                "
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    color: #dc2626;
                  "
                  >close</mat-icon
                >
              </button>
            </div>
            <div
              *ngIf="!isProcesandoRail(element)"
              style="display: flex; gap: 3px; justify-content: center"
            >
              <button
                title="Copiar"
                (click)="copy(element)"
                [disabled]="disableButton(element.emailOperador)"
                [style.opacity]="
                  disableButton(element.emailOperador) ? '0.4' : '1'
                "
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 28px;
                  height: 28px;
                  border: 1px solid #d1d5db;
                  border-radius: 6px;
                  background: white;
                  cursor: pointer;
                "
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    color: #1c593d;
                  "
                  >content_copy</mat-icon
                >
              </button>
              <button
                title="Pagar"
                (click)="openSendTransactionModal(element)"
                [disabled]="
                  disableButton(element.emailOperador) ||
                  !element.precio_compra ||
                  element.precio_compra === 0 ||
                  counter >= 1 ||
                  saldosNoCoinciden
                "
                [style.opacity]="
                  disableButton(element.emailOperador) ||
                  !element.precio_compra ||
                  element.precio_compra === 0 ||
                  counter >= 1 ||
                  saldosNoCoinciden
                    ? '0.4'
                    : '1'
                "
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 28px;
                  height: 28px;
                  border: 1px solid #bbf7d0;
                  border-radius: 6px;
                  background: #f0fdf4;
                  cursor: pointer;
                "
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    color: #16a34a;
                  "
                  >done</mat-icon
                >
              </button>
              <button
                title="Editar"
                (click)="openEditTransactionModal(element)"
                [disabled]="disableButton(element.emailOperador)"
                [style.opacity]="
                  disableButton(element.emailOperador) ? '0.4' : '1'
                "
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 28px;
                  height: 28px;
                  border: 1px solid #bfdbfe;
                  border-radius: 6px;
                  background: #eff6ff;
                  cursor: pointer;
                "
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    color: #2563eb;
                  "
                  >edit</mat-icon
                >
              </button>
              <button
                title="Rechazar"
                (click)="openRejectTransactionModal(element)"
                [disabled]="disableButton(element.emailOperador)"
                [style.opacity]="
                  disableButton(element.emailOperador) ? '0.4' : '1'
                "
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 28px;
                  height: 28px;
                  border: 1px solid #fecaca;
                  border-radius: 6px;
                  background: #fef2f2;
                  cursor: pointer;
                "
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    color: #dc2626;
                  "
                  >close</mat-icon
                >
              </button>
              <button
                title="Reasignar"
                (click)="reasign(element)"
                [disabled]="disableButton(element.emailOperador)"
                [style.opacity]="
                  disableButton(element.emailOperador) ? '0.4' : '1'
                "
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 28px;
                  height: 28px;
                  border: 1px solid #fde68a;
                  border-radius: 6px;
                  background: #fffbeb;
                  cursor: pointer;
                "
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    color: #f59e0b;
                  "
                  >edit_note</mat-icon
                >
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>

  <!-- Cards Mobile -->
  <div class="lg:hidden space-y-3" *ngIf="dataSource">
    <div
      *ngFor="let element of dataSource.filteredData; let i = index"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'"
    >
      <!-- Card header -->
      <div
        class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(i)"
        [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'"
      >
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="change($event, element.id)"
            [disabled]="
              checkEmailOperador(element.emailOperador || '') ||
              isProcesandoRail(element)
            "
            [checked]="element.emailOperador ? true : false"
          >
          </mat-checkbox>
          <span
            class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full shrink-0"
            >#{{ element.id }}</span
          >
          <span class="text-xs font-semibold text-gray-700 truncate"
            >{{ element.cuentaBeneficiario.nombre }}
            {{ element.cuentaBeneficiario.apellidos }}</span
          >
          <span class="text-xs font-bold shrink-0" style="color: #1e5a3f">
            {{
              element.totalMonedaDestino | currency: "$" : "symbol" : "1.0-2"
            }}
          </span>
        </div>
        <mat-icon
          class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="
            expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'
          "
        >
          expand_more
        </mat-icon>
      </div>

      <!-- Card body -->
      <div
        *ngIf="expandedCardId === i"
        class="px-3 pb-3 border-t border-gray-100"
      >
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div>
            <span
              class="text-gray-400 font-semibold uppercase"
              style="font-size: 0.65rem"
              >Ruta</span
            >
            <p class="text-gray-700 font-medium mt-0.5">
              {{ element.paisOrigen }} - {{ element.paisDestino }}
            </p>
          </div>
          <div>
            <span
              class="text-gray-400 font-semibold uppercase"
              style="font-size: 0.65rem"
              >DNI</span
            >
            <p class="text-gray-700 font-mono font-medium mt-0.5">
              {{ element.cuentaBeneficiario.numeroID }}
            </p>
          </div>
          <div>
            <span
              class="text-gray-400 font-semibold uppercase"
              style="font-size: 0.65rem"
              >Banco Destino</span
            >
            <p class="text-gray-700 font-medium mt-0.5">
              {{ element.cuentaBeneficiario.banco?.nombre }}
            </p>
          </div>
          <div>
            <span
              class="text-gray-400 font-semibold uppercase"
              style="font-size: 0.65rem"
              >Tipo Cuenta</span
            >
            <p class="text-gray-700 font-medium mt-0.5">
              {{ element.cuentaBeneficiario.tipoCuenta?.nombre?.toUpperCase() }}
            </p>
          </div>
          <div class="col-span-2">
            <span
              class="text-gray-400 font-semibold uppercase"
              style="font-size: 0.65rem"
              >Número Cuenta</span
            >
            <p class="text-gray-700 font-mono font-medium mt-0.5">
              {{ element.cuentaBeneficiario.numeroCuenta }}
            </p>
          </div>
          <div class="col-span-2">
            <span
              class="text-gray-400 font-semibold uppercase"
              style="font-size: 0.65rem"
              >Monto Destino</span
            >
            <p class="font-bold mt-0.5" style="color: #1e5a3f">
              {{
                element.totalMonedaDestino | currency: "$" : "symbol" : "1.0-2"
              }}
              {{ element.monedaDestino }}
            </p>
          </div>
        </div>

        <!-- Precio compra input -->
        <div class="mt-3 pt-3 border-t border-gray-100">
          <div class="flex items-end gap-2">
            <mat-form-field appearance="outline" class="modern-field flex-1">
              <mat-label>Precio compra</mat-label>
              <input
                matInput
                matInputCommified
                appOnlynumber
                [id]="'valorCompra' + element.id"
                [(ngModel)]="element.precio_compra"
                [disabled]="
                  disableButton(element.emailOperador || '') ||
                  isProcesandoRail(element)
                "
              />
              <span matTextPrefix>$&nbsp;</span>
            </mat-form-field>
            <button
              title="Guardar precio"
              (click)="setPurchaseValue(element.id, element.id)"
              [disabled]="
                disableButton(element.emailOperador || '') ||
                isProcesandoRail(element)
              "
              [style.opacity]="
                disableButton(element.emailOperador || '') ||
                isProcesandoRail(element)
                  ? '0.4'
                  : '1'
              "
              class="mb-1"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                border: 1px solid #bbf7d0;
                border-radius: 8px;
                background: #f0fdf4;
                cursor: pointer;
              "
            >
              <mat-icon
                style="
                  font-size: 18px;
                  width: 18px;
                  height: 18px;
                  color: #16a34a;
                "
                >save</mat-icon
              >
            </button>
          </div>
        </div>

        <!-- Action buttons -->
        <!-- Candado visual mobile: si el rail automático (N58 / Banco Plaza)
             procesa la tx, se ocultan las acciones y se muestra el chip. -->
        <div
          *ngIf="isProcesandoRail(element)"
          class="flex items-center justify-center gap-2 mt-3 pt-3 border-t border-gray-100"
        >
          <span
            style="
              display: inline-flex;
              align-items: center;
              gap: 6px;
              padding: 8px 16px;
              background: #fef9c3;
              color: #92400e;
              border-radius: 9999px;
              font-size: 0.8rem;
              font-weight: 700;
            "
          >
            <mat-icon style="font-size: 16px; width: 16px; height: 16px"
              >hourglass_top</mat-icon
            >
            Procesando · {{ procesandoRail(element) }}
          </span>
          <!-- Rail procesando (N58 / Banco Plaza): sólo se permite Rechazar. -->
          <button
            title="Rechazar"
            (click)="openRejectTransactionModal(element)"
            style="
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 6px 12px;
              border: 1px solid #fecaca;
              border-radius: 8px;
              background: #fef2f2;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 600;
              color: #dc2626;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #dc2626"
              >close</mat-icon
            >
            Rechazar
          </button>
        </div>
        <div
          *ngIf="!isProcesandoRail(element)"
          class="flex flex-wrap gap-2 mt-3 pt-3 border-t border-gray-100"
        >
          <button
            title="Copiar"
            (click)="copy(element)"
            [disabled]="disableButton(element.emailOperador || '')"
            [style.opacity]="
              disableButton(element.emailOperador || '') ? '0.4' : '1'
            "
            style="
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 6px 12px;
              border: 1px solid #d1d5db;
              border-radius: 8px;
              background: white;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 600;
              color: #374151;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #1c593d"
              >content_copy</mat-icon
            >
            Copiar
          </button>
          <button
            title="Pagar"
            (click)="openSendTransactionModal(element)"
            [disabled]="
              disableButton(element.emailOperador || '') ||
              !element.precio_compra ||
              element.precio_compra === 0 ||
              counter >= 1 ||
              saldosNoCoinciden
            "
            [style.opacity]="
              disableButton(element.emailOperador || '') ||
              !element.precio_compra ||
              element.precio_compra === 0 ||
              counter >= 1 ||
              saldosNoCoinciden
                ? '0.4'
                : '1'
            "
            style="
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 6px 12px;
              border: 1px solid #bbf7d0;
              border-radius: 8px;
              background: #f0fdf4;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 600;
              color: #16a34a;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #16a34a"
              >done</mat-icon
            >
            Pagar
          </button>
          <button
            title="Editar"
            (click)="openEditTransactionModal(element)"
            [disabled]="disableButton(element.emailOperador || '')"
            [style.opacity]="
              disableButton(element.emailOperador || '') ? '0.4' : '1'
            "
            style="
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 6px 12px;
              border: 1px solid #bfdbfe;
              border-radius: 8px;
              background: #eff6ff;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 600;
              color: #2563eb;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #2563eb"
              >edit</mat-icon
            >
            Editar
          </button>
          <button
            title="Rechazar"
            (click)="openRejectTransactionModal(element)"
            [disabled]="disableButton(element.emailOperador || '')"
            [style.opacity]="
              disableButton(element.emailOperador || '') ? '0.4' : '1'
            "
            style="
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 6px 12px;
              border: 1px solid #fecaca;
              border-radius: 8px;
              background: #fef2f2;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 600;
              color: #dc2626;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #dc2626"
              >close</mat-icon
            >
            Rechazar
          </button>
          <button
            title="Reasignar"
            (click)="reasign(element)"
            [disabled]="disableButton(element.emailOperador || '')"
            [style.opacity]="
              disableButton(element.emailOperador || '') ? '0.4' : '1'
            "
            style="
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 6px 12px;
              border: 1px solid #fde68a;
              border-radius: 8px;
              background: #fffbeb;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 600;
              color: #f59e0b;
            "
          >
            <mat-icon
              style="font-size: 14px; width: 14px; height: 14px; color: #f59e0b"
              >edit_note</mat-icon
            >
            Reasignar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
